import { useMutation } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import { LoginResponse } from 'Types/LoginResponse'

type Params = {
  email: string
  password: string
  forceVerification?: boolean
}
const login = (params: Params) =>
  request<LoginResponse>({
    url: `auth`,
    method: 'POST',
    data: { ...params },
    hideErrorToaster: true,
  }) as Promise<LoginResponse>

export const useLogin = () => useMutation(login)
